export const WalletLoadedEvent = 'hederaWalletLoaded';
export const WalletUpdatedEvent = 'hederaWalletUpdated';
export const WalletLockedEvent = 'hederaWalletLocked';
export var HederaNetwork;
(function (HederaNetwork) {
    HederaNetwork["Mainnet"] = "Mainnet";
    HederaNetwork["Testnet"] = "Testnet";
})(HederaNetwork || (HederaNetwork = {}));
